import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAnalytics } from 'modules/reviews/pages/performance/Show/Analytics/analyticsContext'
import type Review from 'modules/reviews/store/models/v2/Review'
import FilteredBlankSlate from 'modules/surveys/components/Analytics/_FilterBlankSlate'
import { GroupedBy } from 'modules/surveys/store/models/AnalyticResult'
import { AggregateOperations } from 'modules/surveys/store/models/AnalyticResult'

import BlankSlate from '../BlankSlate'
import { title } from '../utilities'
import Filters from './Filters'
import Heatmap from './Heatmap'
import ScoreForm from './ScoreForm'

interface Props {
  form: Review
}

const ScoreResults = ({ form }: Props) => {
  const { analyticResults, reviewAnalyticsFilter } = useAnalytics()
  const isFilterApplied = reviewAnalyticsFilter?.default.length

  const scoreForm = React.useRef(
    new ScoreForm({
      grouped_by: GroupedBy.Questions,
      aggregate_operation: AggregateOperations.Avg,
    })
  ).current

  if (!analyticResults.length && isFilterApplied) return <FilteredBlankSlate />

  if (!analyticResults.length) {
    return <BlankSlate />
  }

  if (analyticResults.numeric.length === 0) {
    return <BlankSlate numericalResults />
  }

  return (
    <Box gap="s32">
      <Filters scoreForm={scoreForm} />
      {analyticResults.numeric.map((numericResult: any) => (
        <Heatmap
          key={numericResult.get('id')}
          numericResult={numericResult}
          scoreForm={scoreForm}
          title={title(form.attributes.name, numericResult.typeOfReviewer)}
        />
      ))}
    </Box>
  )
}

export default observer(ScoreResults)
